/**
 * Express area kind
 */
export enum BlackBoxDeviceEvent {
  READ_TAG = 0,
}
